import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TitleUpdater = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let title = "Thành Nam PC - Điện tử & Điện máy Quảng Ninh";
    let description = "Thành Nam PC - Đơn vị uy tín hàng đầu tại Quảng Ninh chuyên cung cấp thiết bị điện tử, máy tính, laptop và các sản phẩm điện máy chính hãng.";

    // --- LUỒNG KHÁCH (GUEST) ---
    if (path === '/') title = "Thành Nam PC | Trang chủ";
    else if (path.startsWith('/san-pham/')) {
        title = "Thành Nam PC | Sản phẩm";
        description = "Khám phá các sản phẩm công nghệ, linh kiện máy tính và điện máy chính hãng giá tốt nhất tại Thành Nam PC Quảng Ninh.";
    }
    else if (path === '/login') title = "Đăng nhập | Thành Nam PC";
    else if (path === '/register') title = "Đăng ký tài khoản | Thành Nam PC";
    else if (path === '/cart') title = "Giỏ hàng | Thành Nam PC";
    else if (path.startsWith('/danh-muc/')) title = "Danh mục sản phẩm | Thành Nam PC";
    else if (path === '/tin-tuc') {
        title = "Tin tức công nghệ | Thành Nam PC";
        description = "Cập nhật tin tức công nghệ mới nhất, mẹo vặt máy tính và thông tin khuyến mãi các mặt hàng điện máy tại Thành Nam PC.";
    }
    else if (path.startsWith('/tin-tuc/')) title = "Chi tiết tin tức | Thành Nam PC";
    else if (path === '/search') title = "Tìm kiếm sản phẩm | Thành Nam PC";

    // --- LUỒNG USER ---
    else if (path === '/profile') title = "Hồ sơ cá nhân | Thành Nam PC";
    else if (path === '/my-orders') title = "Đơn hàng của tôi | Thành Nam PC";
    else if (path === '/profile/addresses') title = "Sổ địa chỉ | Thành Nam PC";
    else if (path === '/profile/password') title = "Đổi mật khẩu | Thành Nam PC";
    else if (path === '/checkout') title = "Thanh toán đơn hàng | Thành Nam PC";

    // --- LUỒNG ADMIN ---
    else if (path.startsWith('/admin')) {
      title = "Quản trị hệ thống | Thành Nam PC";
      if (path === '/admin') title = "Dashboard | Admin";
      else if (path.includes('/products')) title = "Quản lý sản phẩm | Admin";
      else if (path.includes('/orders')) title = "Quản lý đơn hàng | Admin";
      else if (path.includes('/accounts')) title = "Quản lý tài khoản | Admin";
      else if (path.includes('/menus')) title = "Cấu hình Menu | Admin";
      else if (path.includes('/settings')) title = "Cài đặt hệ thống | Admin";
    }

    document.title = title;
    let metaDescriptionTag = document.querySelector('meta[name="description"]');
    if (metaDescriptionTag) {
        metaDescriptionTag.setAttribute("content", description);
    }
  }, [location]);

  return null;
};

export default TitleUpdater;